export default "__VITE_ASSET__e4015154__"